import script from "./IntroductionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroductionItem.vue?vue&type=script&setup=true&lang=js"

import "./IntroductionItem.vue?vue&type=style&index=0&id=63ac0da6&lang=scss"

const __exports__ = script;

export default __exports__